var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("input", { attrs: { type: "file" }, on: { change: _vm.getBase64 } }),
      _vm._v(" "),
      _c("vue-croep", {
        ref: "croep",
        attrs: { src: _vm.src },
        on: {
          cropped: function($event) {
            _vm.image = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.image
        ? _c("img", { staticClass: "image", attrs: { src: _vm.image } })
        : _vm._e(),
      _vm._v(" "),
      _c("button", { on: { click: _vm.crop } }, [_vm._v("crop")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }